import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import { Navbar, Nav, Button, Container } from 'react-bootstrap';

import uvegLogo from './LOGO 2.png';
import coachBlockchainLogo from './logo1.png';
// import educaLogo from './Escudo-IE.png';

import styles from './Navigation.module.css';

const EXCLUDE_STICKY_ROUTES = ['/auth/login', '/auth']; // rutas donde NO quieres que se “ancle”

const Navigation = ({ }) => {
  const { pathname } = useLocation();
  const stickyDisabled = EXCLUDE_STICKY_ROUTES.some(p => pathname.startsWith(p));

  const [isDocked, setIsDocked] = useState(false);
  const navRef = useRef(null);

  // Guardamos la altura para el spacer anti-salto
  useEffect(() => {
    const el = navRef.current;
    if (!el) return;
    const h = el.offsetHeight || 0;
    document.documentElement.style.setProperty('--nav-height', `${h}px`);
  }, []);

  // Activa “anclado” solo cuando hay scroll (>8px) y no en rutas excluidas
  useEffect(() => {
    if (stickyDisabled) {
      setIsDocked(false);
      return;
    }
    const onScroll = () => {
      setIsDocked(window.scrollY > 8);
    };
    onScroll(); // estado inicial
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [stickyDisabled]);

  return (
    <>
      <style>{`
        .nav-serif-root, .nav-serif-root * {
          font-family: Georgia, "Times New Roman", Times, serif;
          letter-spacing: 0.01em;
        }
      `}</style>

      <div className={styles.navWrapper}>
        {/* Spacer sólo cuando la barra está fija */}
        {isDocked && <div className={styles.navSpacer} aria-hidden="true" />}

        <Navbar
          ref={navRef}
          expand="lg"
          variant="dark"
          className={`nav-serif-root ${styles.uvegNavbar} ${styles.stickyShadow} ${isDocked ? styles.fixedTop : ''}`}
        >
          <Container>
            {/* Logos simétricos */}
            <Navbar.Brand className={styles.brandBlock}>
              <img
                src={uvegLogo}
           
                className={`${styles.brandLogo} ${styles.uvegHalo}`}
                alt="UVEG"
                draggable="false"
              />
              <img
                src={coachBlockchainLogo}
       
                className={styles.brandLogoB}
                alt="Coach Blockchain"
                draggable="false"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="primaryNavbar" />
            <Navbar.Collapse id="primaryNavbar">
              <Nav className="me-auto">
                <Nav.Link
                  as={NavLink}
                  to="/"
                  end
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`
                  }
                >
                  Inicio
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/NFTs"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  NFTs
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/blockchain"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  Formación
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/roadmap"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  Ruta
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/about-us"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  Conócenos
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/guia"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  Guía
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/acceso"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  Acceso
                </Nav.Link>

                <Nav.Link as={NavLink} to="/course/ia-respuestas"
                  className={({ isActive }) => `${styles.navLink} ${isActive ? styles.activeNavLink : ""}`}>
                  FAQ Inteligente
                </Nav.Link>
              </Nav>

              <Nav>
                {/* Botón INICIAR con estado activo dorado al estar en /course/register */}
                <NavLink
                  to="/course/register"
                  end
                  className={({ isActive }) =>
                    `mx-2 ${isActive ? styles.linkButtonActive : ""}`
                  }
                >
                  <Button variant="outline-light" className={styles.connectButton}>
                    Iniciar
                  </Button>
                </NavLink>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Navigation;
